var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-end"},[_c('div',{staticClass:"auth-language-select-wrap"},[_c('select-lang',{staticClass:"auth-language-select",on:{"change:language":_vm.change_language}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }